import React from 'react'
import { Row, Col } from 'react-bootstrap'
import classNames from 'classnames'
import styles from './Blocks.module.scss'
import Link from 'next/link'

const Blocks = ({ id, items = [], wrapperClass = null, blockClass = null }) => {
  const getBlockClassNames = (block) => {
    const classNames = [styles.blockDefaultState]
    if (block.hoverHtml) {
      classNames.push(styles.hasOverlay)
    } else if (block.disabled) {
      classNames.push(styles.disabledBlock)
    }
    return classNames
  }

  const getStatusClassNames = (status, customColour) => {
    const classNames = [styles.labelTab]
    if (status) {
      classNames.push(styles[status.toString().toLowerCase()])
    }
    if (customColour) {
      classNames.push(styles[customColour])
    }

    return classNames
  }

  const BlockInner = ({ block }) => {
    return (
      <>
        {block.hoverHtml && <div className={styles.hoverHtml}>{block.hoverHtml}</div>}
        <div className={classNames(styles.serviceLink)}>
          {block.icon && (
            <div className={classNames(styles.iconContainer)}>
              <img src={'/images/' + block.icon} className="icon" alt={block.title + ' icon'} />
            </div>
          )}
          <p className={classNames(styles.title)}>{block.title}</p>
          <div className={classNames(styles.desc)}>{block.desc}</div>
          {block.children && <div className="custom mt-2">{block.children}</div>}
          {block.tabText && (
            <div className={classNames(styles.status)}>
              <div
                className={classNames(getStatusClassNames(block.tabText, block.tabColour || null))}
              >
                <span>{block.tabText}</span>
              </div>
            </div>
          )}
        </div>
      </>
    )
  }

  const onBlockClick = async (event, block) => {
    event.preventDefault()
    if (block.joinAction) {
      await block.joinAction(block)
    }
  }

  const colDefaultClassName = 'col-12 col-sm-6 col-lg-4 col-xl-3'
  return (
    <Row id={id} className={classNames(styles.blocksWrapper, { [wrapperClass]: wrapperClass })}>
      {items.map((block, index) => (
        <Col
          key={`${index}-${block.blockId}`}
          className={classNames(styles.blockColumn, {
            [blockClass]: blockClass && !block.colClassName,
            [colDefaultClassName]: !blockClass && !block.colClassName,
            [block.colClassName]: block.colClassName
          })}
        >
          <div className={classNames(styles.block, getBlockClassNames(block))}>
            {block.joinAction ? (
              <Link key={index} href={'#'}>
                <a
                  {...(block?.id && { id: block.id })}
                  className={classNames(styles.blockLink, block.className)}
                  onClick={async (event) => {
                    await onBlockClick(event, block)
                  }}
                  role="button"
                  tabIndex={0}
                >
                  <BlockInner key={block.blockId} block={block} />
                </a>
              </Link>
            ) : block.url ? (
              <Link key={index} href={block.url}>
                <a
                  {...(block?.id && { id: block.id })}
                  className={classNames(styles.blockLink, block.className)}
                  role="button"
                  tabIndex={0}
                  target={block.target ? block.target : '_self'}
                >
                  <BlockInner key={block.blockId} block={block} />
                </a>
              </Link>
            ) : block.className ? (
              <div key={index} className={classNames(block.className)}>
                <BlockInner key={block.blockId} block={block} />
              </div>
            ) : (
              <BlockInner key={block.blockId} block={block} />
            )}
          </div>
        </Col>
      ))}
    </Row>
  )
}

export default Blocks
